export const prices=[
    {
        _id:0,
        name:"Any",
        array:[0,30000]
    },
    {
        _id:1,
        name:"Rs.0-500",
        array:[0,500]
    },
    {
        _id:2,
        name:"Rs.500-1000",
        array:[500,1000]
    },
    {
        _id:3,
        name:"Rs.1000-1500",
        array:[1000,1500]
    },
    {
        _id:4,
        name:"Rs.1500-2000",
        array:[1500,2000]
    },
    {
        _id:5,
        name:"Rs.2000",
        array:[2000,30000]
    }
]